import {
  PrimaryButton,
  Spinner,
  SpinnerSize,
  Stack,
  Text
} from "@fluentui/react";

import type { LineAdditionalServiceListItem } from "../../interfaces";

import { LineAdditionalServicesCard } from ".";

interface LineAdditionalServicesListProps {
  services: LineAdditionalServiceListItem[];
  isLoading: boolean;
  hasPaymentLinkPollingTimedOut: boolean;
  processingServiceId?: number;
  onCreate: () => void;
  onCancel: (service: LineAdditionalServiceListItem) => void;
  onCheckPaymentStatus: (service: LineAdditionalServiceListItem) => void;
  onProcessStep: (service: LineAdditionalServiceListItem) => void;
  onRefreshPaymentLinks: () => void;
}

export function LineAdditionalServicesList({
  services,
  isLoading,
  hasPaymentLinkPollingTimedOut,
  processingServiceId,
  onCreate,
  onCancel,
  onCheckPaymentStatus,
  onProcessStep,
  onRefreshPaymentLinks
}: LineAdditionalServicesListProps): JSX.Element {
  const isProcessing = processingServiceId !== undefined;
  const sortedServices = [...services].sort(
    (serviceA, serviceB) =>
      new Date(serviceB.createdAt).getTime() -
      new Date(serviceA.createdAt).getTime()
  );

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <Stack
        horizontal
        horizontalAlign="space-between"
        verticalAlign="center"
        wrap
        tokens={{ childrenGap: 12 }}
      >
        <Text variant="mediumPlus" styles={{ root: { fontWeight: 600 } }}>
          Serviços registrados
        </Text>
        <PrimaryButton
          iconProps={{ iconName: "Add" }}
          text="Novo Serviço"
          disabled={isProcessing}
          onClick={onCreate}
        />
      </Stack>

      {isLoading && sortedServices.length === 0 && (
        <Stack horizontalAlign="center" tokens={{ padding: 12 }}>
          <Spinner size={SpinnerSize.medium} label="Carregando solicitações" />
        </Stack>
      )}

      {!isLoading && sortedServices.length === 0 && (
        <Text>Nenhum serviço adicional registrado para esta linha.</Text>
      )}

      {sortedServices.length > 0 &&
        sortedServices.map(lineAdditionalService => (
          <LineAdditionalServicesCard
            key={lineAdditionalService.id}
            lineAdditionalService={lineAdditionalService}
            hasPaymentLinkPollingTimedOut={hasPaymentLinkPollingTimedOut}
            isProcessing={isProcessing}
            onCancel={onCancel}
            onCheckPaymentStatus={onCheckPaymentStatus}
            onProcessStep={onProcessStep}
            onRefreshPaymentLinks={onRefreshPaymentLinks}
          />
        ))}
    </Stack>
  );
}
